import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import { EnhancedAccordion } from 'components/enhanced/accordion/EnhancedAccordion';
import { EntityLink } from 'components/ui/EntityLink';
import { ITransportActiveDocument } from 'features/inventory/transport-documents/types';
import { useTranslation } from 'react-i18next';

interface TransportOrderLeftoversProps {
  ddt?: ITransportActiveDocument | null;
  prefix: string;
}

export const TransportOrderLeftovers = ({ ddt, prefix }: TransportOrderLeftoversProps) => {
  const { t } = useTranslation();

  if (!ddt?.order || !ddt?.leftover_items || ddt.leftover_items.length === 0) {
    return null;
  }

  return (
    <EnhancedAccordion
      title={'Rimanenze Ordine da Evadere'}
      subtitle="Articoli originariamente inclusi nell'ordine che rimangono da consegnare"
      buttons={
        <Chip
          label={`${ddt.leftover_items.length} ${
            ddt.leftover_items.length === 1
              ? t(`${prefix}.item`, 'articolo')
              : t(`${prefix}.items`, 'articoli')
          }`}
          size="small"
          color="default"
          sx={{
            fontWeight: 600,
            borderRadius: 1,
            px: 1,
            py: 2,
            backgroundColor: '#29456c',
            color: '#ffffff'
          }}
        />
      }>
      <Box
        sx={{
          display: 'grid',
          gap: 1.5,
          gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 1fr',
            lg: '1fr 1fr 1fr'
          }
        }}>
        {ddt.leftover_items.map((item) => (
          <Card
            key={item.item_id}
            variant="outlined"
            sx={{
              borderRadius: 1.5,
              borderColor: 'rgba(0, 0, 0, 0.08)',
              backgroundColor: '#ffffff',
              transition: 'border-color 0.15s ease',
              '&:hover': {
                borderColor: '#2578b0',
                boxShadow: '0 2px 4px rgba(37, 120, 176, 0.05)'
              }
            }}>
            <CardContent
              sx={{
                p: '14px !important',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2
              }}>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <EntityLink
                  value={item.item_id}
                  label={item.item_name}
                  basePath="tenant/products"
                  maxTextWidth={180}
                  passStateData={item}
                />

                {item.item_description && (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    noWrap
                    display="block"
                    title={item.item_description}
                    sx={{ mt: 0.5 }}>
                    {item.item_description}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  fontSize: '0.875rem',

                  whiteSpace: 'nowrap',
                  px: 1.5,
                  py: 0.5
                }}>
                Q.tà che non partirà: {item.quantity_leftover}
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </EnhancedAccordion>
  );
};
